import { MobileButton } from './MobileButton'

class MobileButtonBuilder {
	constructor (menu) {
		this.menu = menu
	}
	build (selector) {
		const mobileButton = new MobileButton()
		const node = document.querySelector(selector)

		mobileButton
			.setMainNode(node)
			.setTopNode(node.querySelector('.navbar-toggler-icon--top'))
			.setCenterNode(node.querySelector('.navbar-toggler-icon--center'))
			.setBottomNode(node.querySelector('.navbar-toggler-icon--bottom'))
			.setMenu(this.menu)
			.init()

		return mobileButton
	}
}

export { MobileButtonBuilder }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_menu/MobileButtonBuilder.js